<div class="login-wrapper">
  <div class="m-3">
    <mat-card class="pb-5">
      <mat-card-header class="login-header">
        @if (!passwordChanged) {
          <mat-icon class="login-avatar">lock_open</mat-icon>
          <h1 class="login-text text-center">
            {{ "features.reset_password" | transloco }}
          </h1>
        }
        @if (passwordChanged) {
          <mat-icon class="login-avatar">check_circle</mat-icon>
        }
      </mat-card-header>
      <mat-card-content>
        @if (!validResetSession) {
          <div class="warn text-center mt-3">
            {{ "errors.invalid_or_expired_reset_password_token" | transloco }}
          </div>
        }
        @if (validResetSession && !passwordChanged) {
          <div class="mt-5">
            <loren-entity-form
              #form
              [formModel]="userChangePasswordFormModel"
              (submitForm)="submit($event)"
              (formFieldInteraction)="disableSubmitBtn = false"
              >
            </loren-entity-form>
            @if (errors.length > 0) {
              <div class="mb-3">
                @for (error of errors; track error) {
                  <div class="mb-1 warn">
                    {{ error }}
                  </div>
                }
              </div>
            }
            <div class="text-right">
              <button
                [disabled]="disableSubmitBtn"
                matButton="filled"
                (click)="form.onSubmit()"
                >
                {{ "forgotten_password.set_new_password" | transloco }}
              </button>
            </div>
          </div>
        }
        @if (validResetSession && passwordChanged) {
          <div
            class="w-100 text-center mt-3"
            >
            {{ "forgotten_password.new_password_set" | transloco }}
          </div>
        }
      </mat-card-content>
      <div class="w-100 text-center mt-5">
        <a [routerLink]="['/']" class="text-black-50" href="#">{{
          "home.index" | transloco
        }}</a>
      </div>
    </mat-card>
  </div>
</div>
